export type Scalar = string | number | boolean | null;

const MAX_STRING = 200;
const MAX_BYTES = 4096;

// Ids, enums, counts and flags only. Anything structured is dropped rather
// than flattened: a nested object is how names, notes and search text would
// sneak into the store.
export const sanitizeProperties = (
  input: Record<string, unknown> = {}
): Record<string, Scalar> => {
  const out: Record<string, Scalar> = {};
  for (const [key, value] of Object.entries(input)) {
    if (
      value === null ||
      typeof value === 'number' ||
      typeof value === 'boolean'
    ) {
      out[key] = value;
    } else if (typeof value === 'string') {
      out[key] = value.slice(0, MAX_STRING);
    }
  }
  return new TextEncoder().encode(JSON.stringify(out)).length > MAX_BYTES
    ? {}
    : out;
};
